<template>
  <main class="page-operative page-operative-data-analysis page-operative-data-analysis-costs page-operative-data-analysis-costs-new">
    <div class="container">
      <div class="d-flex align-items-center justify-content-between mb-5">
        <PageTitle>Nuovo costo di struttura</PageTitle>
        <app-router-link class="btn btn-outline-primary" :to="{ name: 'operative-company.data-analysis.ga' }">Torna alla lista</app-router-link>
      </div>

      <FormCostoGA v-if="company && userCanEdit" @saved="saveCosto" />
      <div v-else-if="company">Utente non abilitato</div>
    </div>
  </main>
</template>

<script>

import operativePageMixin from '../../../../../mixins/operativePage';

export default {
  name: 'page-operative-company-data-analysis-costs-ga-new',
  mixins: [operativePageMixin],
  components: {
    PageTitle: () => import('../../../../components/Layout/LayoutOperative/PageTitle'),
    FormCostoGA: () => import('../../../../components/Operative/Form/FormCostoGA'),
    AppRouterLink: () => import('../../../../components/Layout/AppRouterLink'),
  },
  methods: {
    saveCosto (costo) {
      this.$log.debug(costo);
      this.$api.addCostoGA(this.company.id, costo)
        .then(() => {
          this.$router.push({
            name: 'operative-company.data-analysis.ga',
            query: {
              forecast: this.$route.query?.forecast || null,
            },
          });
        })
        .catch(this.$log.error)
      ;
    },
  },
};

</script>
